var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action',{attrs:{"show":_vm.$props.show,"edit":_vm.$props.edit,"delete":_vm.$props.delete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }